import { ArrowRight, CalendarRange, GitCompare, Leaf, PackagePlus, Radar } from 'lucide-react';

import { Link } from '@/components/link';
import {
  EMISSIONS_CALCULATOR_URL,
  PORTS_INSIGHTS_URL,
  ROUTING_SEARCH_URL,
  SCHEDULE_SEARCH_URL,
  TRACKING_IMPORT_SINGLE_URL,
} from '@/lib/constants';
import { tv } from '@/utils/styles';
import { trackUser } from '@/utils/tracking';

const quicklinks = [
  { icon: <PackagePlus />, title: 'Track a shipment ', url: TRACKING_IMPORT_SINGLE_URL },
  { icon: <CalendarRange />, title: 'Search schedules', url: SCHEDULE_SEARCH_URL },
  { icon: <Leaf />, title: 'Calculate emissions', url: EMISSIONS_CALCULATOR_URL },
  { icon: <GitCompare />, title: 'Explore routes', url: ROUTING_SEARCH_URL },
  { icon: <Radar />, title: 'Explore ports', url: PORTS_INSIGHTS_URL },
];

const DashboardQuickLinks = () => {
  const { links, quicklink, quicklinkText } = styles();

  const handleClickQuicklink = (name: string) => {
    trackUser.event(`Quicklink: Clicked`, { name });
  };

  return (
    <div className={links()}>
      {quicklinks.map((link) => (
        <Link className={quicklink()} key={link.url} href={link.url} onClick={() => handleClickQuicklink(link.title)}>
          <span className={quicklinkText()}>
            {link.icon}
            {link.title}
          </span>
          <ArrowRight className="size-4 xl:size-5" />
        </Link>
      ))}
    </div>
  );
};

const styles = tv({
  slots: {
    links: 'grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-4 lg:grid-cols-4 xl:grid-cols-5',
    quicklink:
      'flex items-center justify-between rounded-lg border border-grey-300 p-3 text-baseSm font-medium text-blue-600 shadow-sm transition-all duration-200 ease-in-out hover:border-white hover:bg-white hover:shadow lg:p-4',
    quicklinkText: 'flex items-center gap-2 [&_svg]:size-5',
  },
});

export { DashboardQuickLinks };
